function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  opacity: 0.4,
  cx: 37,
  cy: 37,
  r: 36.5,
  stroke: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 37,
  cy: 37,
  r: 34,
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M36.1602 18.299C36.5542 17.6896 37.4458 17.6896 37.8398 18.299L43.6321 27.2587C43.7671 27.4674 43.9749 27.6184 44.2151 27.6822L54.5262 30.4224C55.2276 30.6088 55.5031 31.4567 55.0452 32.0198L48.314 40.2973C48.1572 40.4901 48.0778 40.7344 48.0913 40.9826L48.6716 51.6358C48.711 52.3605 47.9897 52.8845 47.3128 52.623L37.3603 48.7792C37.1284 48.6896 36.8716 48.6896 36.6397 48.7792L26.6872 52.623C26.0103 52.8845 25.289 52.3605 25.3284 51.6358L25.9087 40.9826C25.9222 40.7344 25.8428 40.4901 25.686 40.2973L18.9548 32.0198C18.4969 31.4567 18.7724 30.6088 19.4738 30.4224L29.7849 27.6822C30.0251 27.6184 30.2329 27.4674 30.3679 27.2587L36.1602 18.299Z",
  fill: "#FAC936"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M36.1602 18.299C36.5542 17.6896 37.4458 17.6896 37.8398 18.299L43.6321 27.2587C43.7671 27.4674 43.9749 27.6184 44.2151 27.6822L54.5262 30.4224C55.2276 30.6088 55.5031 31.4567 55.0452 32.0198L48.314 40.2973C48.1572 40.4901 48.0778 40.7344 48.0913 40.9826L48.6716 51.6358C48.711 52.3605 47.9897 52.8845 47.3128 52.623L37.3603 48.7792C37.1284 48.6896 36.8716 48.6896 36.6397 48.7792L26.6872 52.623C26.0103 52.8845 25.289 52.3605 25.3284 51.6358L25.9087 40.9826C25.9222 40.7344 25.8428 40.4901 25.686 40.2973L18.9548 32.0198C18.4969 31.4567 18.7724 30.6088 19.4738 30.4224L29.7849 27.6822C30.0251 27.6184 30.2329 27.4674 30.3679 27.2587L36.1602 18.299Z",
  fill: "url(#paint0_linear)",
  fillOpacity: 0.6
});

var _ref6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 37,
  y1: 17,
  x2: 37,
  y2: 57,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0
})));

var SvgCircleStar = function SvgCircleStar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCircleStar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/circle_star.4f55b18e.svg";
export { ForwardRef as ReactComponent };